import { SupportChannelType } from '../components/Footer/types/Support.types.js';

/** Support working time, format 'h:mm' (MSK zone) */
const SUPPORT_START = '9:00';
const SUPPORT_END = '21:00';
const defaultSupport = {
    phone: '88007073902',
    supportStart: SUPPORT_START,
    supportEnd: SUPPORT_END,
    channels: [
        {
            type: SupportChannelType.TELEGRAM,
            link: 'https://t.me/SravniSupport_bot',
        },
        {
            type: SupportChannelType.EMAIL,
            link: 'help@sravni.ru',
        },
        {
            type: SupportChannelType.PHONE,
            link: '88007073902',
        },
        {
            type: SupportChannelType.WHATSAPP,
            link: 'https://www.acebot.ru/wa?79250233848',
        },
    ],
};

export { defaultSupport };
//# sourceMappingURL=support.js.map
